import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
// src/main.js
import * as Purchases from '@revenuecat/purchases-capacitor'

if (typeof Purchases?.configure === 'function') {
  Purchases.setLogLevel({ level: 'DEBUG' }) // helpful while testing
  Purchases.configure({ apiKey: import.meta.env.VITE_RC_PUBLIC_IOS })
  // Optional: match your Firebase UID for cross-platform analytics
  // const uid = getAuth().currentUser?.uid; if (uid) { Purchases.logIn({ appUserId: uid }) }
}

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
